<script>
    export default {
        data() {
            return {
                priceIncludingTax: false
            }
        },

        mounted() {
            let cookieValue = this.$cookies.get('price-incl-tax');

            if (cookieValue === null) {
                this.setPriceTaxCookie(false);
            }

            this.priceIncludingTax = (cookieValue === 'true');

            bus.$on('tax-price-view-changed', function(priceIncludingTax) {
                this.priceIncludingTax = priceIncludingTax;
            }.bind(this));
        },

        methods: {
            setPriceTaxCookie: function (cookieValue = null) {
                this.$cookies.set('price-incl-tax', cookieValue, '1y');
                bus.$emit('tax-price-view-changed', cookieValue);
            },

            getNetPriceByPriceAndTax: function(price, tax) {
                return parseFloat((parseFloat(price) + parseFloat(tax))).toFixed(2);
            },
        }

    }
</script>
